import { TableOption, TableSource } from '@tripointe/tripointe-cms/types';

import { TOOLTIPS_TEXTS } from './tooltips';

const homesTableTooltips = TOOLTIPS_TEXTS.homesTable;

export const BASE_HOMES_ACTIVE_OPTIONS: TableOption[] = [
  { action: 'edit', src: 'icons/green-edit' },
  { action: 'delete', src: 'icons/delete' },
  { action: 'mobileMenu', src: 'icons/more' }
];

export const BASE_HOMES_ARCHIVED_OPTIONS: TableOption[] = [
  { action: 'unarchive', src: 'icons/unarchive' },
  { action: 'deleteArchive', src: 'icons/delete' },
  { action: 'mobileMenu', src: 'icons/more' }
];

export const BASE_ACTIVE_HOMES_TABLE_CONFIG: TableSource = {
  displayedColumns: [
    'address',
    'homesite',
    'plan',
    'buyers',
    'contractDate',
    'lastLoginDate',
    'division',
    'community',
    'phase',
    'options'
  ],
  displayedTitles: [
    'Address',
    'Homesite #',
    'Plan',
    'Buyer(s)',
    'Contract Date',
    'Last Logged In',
    'Division',
    'Community',
    'Phase',
    'Actions'
  ],
  columnsConfig: [
    { sorting: true },
    { sorting: true },
    { sorting: true },
    { sorting: false },
    { sorting: true },
    { sorting: true },
    { sorting: true },
    { sorting: true },
    { sorting: true },
    { sorting: false }
  ],
  displayedTooltips: [
    homesTableTooltips.address,
    homesTableTooltips.homesite,
    homesTableTooltips.plan,
    homesTableTooltips.buyers,
    homesTableTooltips.contractDate,
    homesTableTooltips.lastLoggedIn,
    homesTableTooltips.division,
    homesTableTooltips.community,
    homesTableTooltips.phase
  ],
  options: null,
  dataSource: []
};

export const BASE_ARCHIVED_HOMES_TABLE_CONFIG: TableSource = {
  displayedColumns: [
    'address',
    'homesite',
    'plan',
    'buyers',
    'contractDate',
    'contractCancelledDate',
    'division',
    'community',
    'phase',
    'options'
  ],
  displayedTitles: [
    'Address',
    'Homesite #',
    'Plan',
    'Buyer(s)',
    'Contract Date',
    'Contract Cancelled Date',
    'Division',
    'Community',
    'Phase',
    'Actions'
  ],
  columnsConfig: [
    { sorting: true },
    { sorting: true },
    { sorting: true },
    { sorting: false },
    { sorting: true },
    { sorting: true },
    { sorting: true },
    { sorting: true },
    { sorting: true },
    { sorting: false }
  ],
  displayedTooltips: [
    homesTableTooltips.address,
    homesTableTooltips.homesite,
    homesTableTooltips.plan,
    homesTableTooltips.buyers,
    homesTableTooltips.contractDate,
    homesTableTooltips.contractCancelledDate,
    homesTableTooltips.division,
    homesTableTooltips.community,
    homesTableTooltips.phase
  ],
  options: null,
  dataSource: []
};
